import React, { useState } from "react";
import styled from "styled-components";

const Styled = styled.div`
  background-color: #eee;
  width: 100%;
  overflow: hidden;
`;

const ProgressBarBar = styled.div`
  height: 3px;
  background-color: #3e8cb3;
  transition: width 0.2s;
`;

interface Props {
  total: number;
  current: number;
}

const ProgressBar: React.FC<Props> = (props) => {
  return (
    <Styled>
      <ProgressBarBar
        style={{ width: `${(props.current / props.total) * 100}%` }}
      />
    </Styled>
  );
};

export default ProgressBar;
